export default __webpack_public_path__ + "static/media/Room7.c1653df0.png";